import refundStatus from '@/helpers/refundStatusHelper'
import {
  availableBarsRestaurantsJobTypes,
  availableCastingJobTypes,
  availableEventSupportJobTypes,
  availableMasterOfCeremoniesJobTypes
} from '@/helpers/availableJobTypeHelper'

export default function () {
  return {
    refundStatus,
    allAvailableJobTypes: [
      ...availableCastingJobTypes,
      ...availableMasterOfCeremoniesJobTypes,
      ...availableEventSupportJobTypes,
      ...availableBarsRestaurantsJobTypes
    ],
  }
}
